export const TOGGLE_LOADING = 'TOGGLE_LOADING';

export const ADD_ERROR = 'ADD_ERROR';
export const DELETE_ERROR = 'DELETE_ERROR';
export const DELETE_ALL_ERRORS = 'DELETE_ALL_ERRORS';
